import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import comboGrid from "@/extension/combo-gird"


addCustomWidgetSchema({
  type: 'comboGrid',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '', // 唯一名称
    defaultValue: new Array(), // 默认值
    label: '多文本输入',
    labelAlign: 'label-right-align',
    labelWidth: '110',
    required: false,
    requiredHint: '',
    //-------------------
    weekCode: '',
    codeValue: '',
    url: '/jumper-mih/nt/ntBaseTemplate/filterTemplate',
    saveTempUrl: '/jumper-mih/nt/ntBaseTemplate/save',
    noEditable: false,
    needTable: true,
    supDia: false,
    subDia: false,
    disabled: false,// 整个组件禁用
    border: false,
    inputClass: 'no-border-input',
    tableHeight: 255,
    placeholder: '请选择',//输入提示文字
    backgroundColor: '#3983b3',
    valColor: '#fff',
    fontSize: '12px',
    bcolor: '#3983b3',
    showSaveTemp: false
  }
})  //加载组件Json Schema


Vue.component(comboGrid.name, comboGrid)  //注册组件

// 注册属性编辑框
PERegister.registerCPEditor('valColor', 'valColor-editor',
  PEFactory.createInputTextEditor('valColor', '选项字体色'))

PERegister.registerCPEditor('showSaveTemp', 'showSaveTemp-editor',
  PEFactory.createBooleanEditor('showSaveTemp', '显示另存模板'))

PERegister.registerCPEditor('bcolor', 'bcolor-editor',
  PEFactory.createInputTextEditor('bcolor', '选项边框色'))

PERegister.registerCPEditor('backgroundColor', 'backgroundColor-editor',
  PEFactory.createInputTextEditor('backgroundColor', '选项背景色'))

PERegister.registerCPEditor('codeValue', 'codeValue-editor',
  PEFactory.createInputTextEditor('codeValue', '字典编码'))

PERegister.registerCPEditor('weekCode', 'weekCode-editor',
  PEFactory.createInputTextEditor('weekCode', '孕周字段名'))

PERegister.registerCPEditor('url', 'url-editor',
  PEFactory.createInputTextEditor('url', '接口地址'))

PERegister.registerCPEditor('saveTempUrl', 'saveTempUrl-editor',
  PEFactory.createInputTextEditor('saveTempUrl', '保存模板url'))

PERegister.registerCPEditor('inputClass', 'inputClass-editor',
  PEFactory.createInputTextEditor('inputClass', '文本框样式'))

PERegister.registerCPEditor('noEditable', 'noEditable-editor',
  PEFactory.createBooleanEditor('noEditable', '是否不可以编辑'))

PERegister.registerCPEditor('needTable', 'needTable-editor',
  PEFactory.createBooleanEditor('needTable', '快捷表格'))

PERegister.registerCPEditor('supDia', 'supDia-editor',
  PEFactory.createBooleanEditor('supDia', '特殊符号'))

PERegister.registerCPEditor('subDia', 'subDia-editor',
  PEFactory.createBooleanEditor('subDia', '上下标'))

PERegister.registerCPEditor('border', 'border-editor',
  PEFactory.createBooleanEditor('border', '文本框边框'))

// PERegister.registerCPEditor('tableHeight', 'tableHeight-editor',
//   PEFactory.createInputNumberEditor('tableHeight', '表格高度'))

// PERegister.registerCPEditor('tableHeight', 'tableHeight-editor',
//   PEFactory.createInputNumberEditor('tableHeight', '表格高度'))


//注册字段组件的代码生成器
// registerFWGenerator('alert', alertTemplateGenerator)  

